import { Pagination, PaginationQuery, EmployerAdminFindOneDto } from '@libs/dto';
import { Employer } from '@libs/models';

import { api } from '../common.api';

export const employerAdminApi = api.injectEndpoints({
  endpoints: (build) => ({
    employerAdminSearch: build.query<Pagination<Employer>, PaginationQuery>({
      query: ({ q, page = 1, limit = 10 }) => ({
        url: '/employer/admin/search',
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['Employer'],
    }),
    employerAdminFindOne: build.query<EmployerAdminFindOneDto, string>({
      query: (id) => ({
        url: `/employer/admin/${id}`,
        method: 'GET',
      }),
      providesTags: ['Employer'],
    }),
  }),
});

export const {
  useEmployerAdminSearchQuery,
  useLazyEmployerAdminSearchQuery,
  useEmployerAdminFindOneQuery,
} = employerAdminApi;
